import getConfigTID from "@/lib/getConfigTID"
import { syncStoredUserInfo } from "@/components/client/Datalayer/utilities"
import { clearKnownUser } from "@/lib/knownUserCookie"

/**
 * Ends the Trimble Identity (TID) session: clears locally stored user/auth
 * data, then redirects to TID's logout endpoint (so the SSO session itself is
 * terminated) and back to the current page afterward.
 *
 * Mirrors LayoutComponent's `handleLogout` for the global nav — this is the
 * Trimble Developer header's equivalent, minus the ecom/account-switcher
 * cleanup that doesn't apply here. Caller is still responsible for
 * dispatching `LOG_OUT` to the login context.
 */
export function handleTIDSignOut(idToken?: string | null): void {
  const { url, redirect_uri } = getConfigTID()
  const logoutBaseUrl = url.replace("/oauth/token", "/oauth")
  const returnPath = encodeURIComponent(
    `${window.location.origin}${window.location.pathname}`,
  )

  syncStoredUserInfo(null)
  clearKnownUser()
  localStorage.removeItem("id_link")
  localStorage.removeItem("currency")
  localStorage.removeItem("country")

  window.open(
    `${logoutBaseUrl}/logout?id_token_hint=${idToken ?? ""}&post_logout_redirect_uri=${redirect_uri}&state=${returnPath}`,
    "_self",
  )
}
